/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/star'
export default icon
